import { createContext } from 'react'

import { SafeAreaTextColor } from './safe-area-provider'

export const SafeAreaContext = createContext({
  insetTop: 0,
  expand: (_: boolean) => {},
  changeTextColor: (_: SafeAreaTextColor) => () => {},
})
